import http from "./index"

// 业务统计事件 business--业务类型
export function businessStatis(business) {
  return http.get(`/frontClickVolume/click/${business}`)
}